var _effectorFileName = "/src/page-content/teachers/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { AboutTeachers } from '@/page-content/teachers/components/about-teachers';
import { Teachers } from '@/page-content/teachers/components/teachers';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { ForWhomOurLessons } from '@/widgets/layouts/main/for-whom-our-lessons';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const TeachersPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Преподаватели" description={`Наши учителя – это целая команда непрерывно самосовершенствующихся профессионалов. Помимо английского, все учителя знают тонкости собеседований в международные компании и как устроен HR процесс. Можем провести mock интервью или подсказать как лучше заполнить LinkedIn. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Преподаватели`} description={`Наши учителя – это целая команда непрерывно самосовершенствующихся профессионалов. Помимо английского, все учителя знают тонкости собеседований в международные компании и как устроен HR процесс. Можем провести mock интервью или подсказать как лучше заполнить LinkedIn. ${APP_TITLE} – деловой английский для работы.`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} about={['английский', 'онлайн', 'консультации', 'преподаватели']} />

      <AboutTeachers />

      <Teachers />

      <ForWhomOurLessons />

      <Reviews />

      <CallToAction withForm />
    </>;
};
TeachersPage.Layout = MainLayout;